import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";

const MetricsContentLoader = styled(ContentLoader)`
  min-width: 10.71rem;
  height: 8.57rem;
`;

const MetricsWrapper = styled.div`
  height: 8.57rem;
  display: grid;
  grid-template-columns: auto auto auto auto;
  width: 100%;
`;
const CleanTypeContentLoader = styled(ContentLoader)`
  height: 8.57rem;
  width: 100%;
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 6fr) minmax(auto, 4fr);
  width: 100%;
`;

export const TopLevelMetricsContentLoader = () => {
  return (
    <Wrapper>
      <MetricsWrapper>
        <MetricsContentLoader>
          <rect fill="#000000" height="37" width="52" x="-0.5" y="6" />
          <rect fill="#000000" height="13" width="147" x="-0.5" y="56" />
          <rect fill="#000000" height="13" width="99" x="-0.5" y="78" />
        </MetricsContentLoader>
        <MetricsContentLoader>
          <rect fill="#000000" height="37" width="52" x="-0.5" y="6" />
          <rect fill="#000000" height="13" width="147" x="-0.5" y="56" />
          <rect fill="#000000" height="13" width="99" x="-0.5" y="78" />
          <rect fill="#000000" height="13" width="87" x="-0.5" y="100" />
        </MetricsContentLoader>
        <MetricsContentLoader>
          <rect fill="#000000" height="13" width="147" x="-0.5" y="56" />
          <ellipse cx="14" cy="21.24641" fill="#000000" rx="14.5" ry="14.5" />
          <ellipse
            cx="35.25598"
            cy="21.24641"
            fill="#000000"
            rx="14.5"
            ry="14.5"
          />
          <ellipse
            cx="58.86346"
            cy="20.99521"
            fill="#000000"
            rx="14.5"
            ry="14.5"
          />
          <ellipse
            cx="81.21997"
            cy="20.99521"
            fill="#000000"
            rx="14.5"
            ry="14.5"
          />
          <ellipse
            cx="100.07499"
            cy="16.22248"
            fill="#000000"
            rx="9.72726"
            ry="9.72726"
          />
        </MetricsContentLoader>
        <MetricsContentLoader>
          <rect fill="#000000" height="37" width="52" x="-0.5" y="6" />
          <rect fill="#000000" height="13" width="147" x="-0.5" y="56" />
          <rect fill="#000000" height="13" width="99" x="-0.5" y="78" />
        </MetricsContentLoader>
      </MetricsWrapper>
      <CleanTypeContentLoader>
        <rect fill="#000" height="10%" width="10%" x="0" y="0" />

        <rect fill="#000" height="10%" width="20%" x="0" y="25%" />
        <rect fill="#000" height="10%" width="20%" x="33%" y="25%" />
        <rect fill="#000" height="10%" width="20%" x="66%" y="25%" />

        <rect fill="#000" height="10%" width="20%" x="0" y="50%" />
        <rect fill="#000" height="10%" width="20%" x="33%" y="50%" />
        <rect fill="#000" height="10%" width="20%" x="66%" y="50%" />

        <rect fill="#000" height="10%" width="20%" x="0" y="75%" />
        <rect fill="#000" height="10%" width="20%" x="33%" y="75%" />
        <rect fill="#000" height="10%" width="20%" x="66%" y="75%" />
      </CleanTypeContentLoader>
    </Wrapper>
  );
};
